import React, { useState, useEffect } from 'react';
import Swal from 'sweetalert2';
import Modal from './Modal.jsx';

/**
 * Modal "Enviar ..." del botón eMail de V1 (label "Email", input, botón "Enviar").
 * Props: `{ open, onClose, titulo, emailInicial, onEnviar(email) }`.
 * `onEnviar` debe retornar una Promise (arma el PDF y llama a `enviarCorreoAdjunto`, ver
 * `services/api/mail.js`). Este componente maneja el estado de envío y muestra los mismos
 * Swal que V1: éxito "Good job! / Enviado con exito" (y cierra), error "Oops... / Something
 * went wrong!" con el mensaje del backend en el footer (y se queda abierto).
 */
export default function EmailModal({ open, onClose, titulo = 'Enviar', emailInicial = '', onEnviar }) {
  const [email, setEmail] = useState(emailInicial || '');
  const [enviando, setEnviando] = useState(false);

  useEffect(() => {
    if (open) setEmail(emailInicial || '');
  }, [open, emailInicial]);

  async function enviar() {
    if (enviando) return;
    const destino = email.trim();
    if (!destino) {
      Swal.fire({ icon: 'error', title: 'Oops...', text: 'Something went wrong!', footer: 'Captura un Email' });
      return;
    }
    setEnviando(true);
    try {
      await onEnviar(destino);
      onClose?.();
      Swal.fire('Good job!', 'Enviado con exito', 'success');
    } catch (error) {
      console.log(error);
      Swal.fire({
        icon: 'error',
        title: 'Oops...',
        text: 'Something went wrong!',
        footer: error?.response?.data?.error?.message || error?.message || 'Ocurrió un error inesperado',
      });
    } finally {
      setEnviando(false);
    }
  }

  return (
    <Modal
      open={open}
      onClose={onClose}
      title={titulo}
      width="max-w-sm"
      footer={
        <button
          type="button"
          onClick={enviar}
          disabled={enviando}
          className="px-3 py-1.5 text-sm rounded-md bg-green-600 text-white hover:bg-green-700 disabled:opacity-50"
        >
          {enviando ? 'Enviando...' : 'Enviar'}
        </button>
      }
    >
      <label className="block text-sm text-slate-700 mb-1">Email</label>
      <input
        type="text"
        value={email}
        onChange={(e) => setEmail(e.target.value)}
        onKeyDown={(e) => e.key === 'Enter' && enviar()}
        className="w-full rounded-md border border-slate-300 px-3 py-1.5 text-sm"
        autoFocus
      />
    </Modal>
  );
}
